const minHeight = typeof window !== "undefined" && window.innerHeight;
const minWidth = typeof window !== "undefined" && window.innerWidth;

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: "100vh",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center"
  },
  textField: {
    marginRight: theme.spacing.unit * 2,
    display: "block",
    minWidth: minWidth / 2,
    marginBottom: 30
  },
  block: {
    display: "block"
  },
  modal: {
    minHeight: 600,
    minWidth: 600,
    maxWidth: minWidth / 1.5
  },
  modalHeader: {
    fontWeight: "600!important",
    fontSize: "1.2rem!important"
  },
  form: {
    height: 430,
    overflowY: "scroll"
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: "white",
    minWidth: 40,
    "&:focus": {
      outline: "none"
    },
    "&:hover": {
      backgroundColor: "#fd5622"
    }
  },
  submit: {
    marginLeft: theme.spacing.unit * 2,
    backgroundColor: theme.palette.accent,
    color: "white",
    "&:focus": {
      outline: "none"
    },
    "&:hover": {
      backgroundColor: "#fd5622"
    }
  },
  close: {
    padding: 0,
    minWidth: 40
  },
  flex: {
    flex: 1
  },
  summary: {
    padding: theme.spacing.unit
  },
  error: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#D42E4C",
    padding: 10,
    textAlign: "center",
    "& h3": {
      color: "white",
      fontSize: 18
    },
    "& p": {
      color: "white"
    }
  }
});

export default styles;
